export default "__VITE_ASSET__2d7c31dc__"